/**
 * Durable client-minted anonymous id.
 *
 * Lets signed-out create-agent turns be attributed server-side. Unlike the
 * per-session agent_session_id, this id is minted once and PERSISTS across
 * turns and across login/logout — it is never cleared on logout/anon so the
 * same anonymous visitor stays linkable over time.
 */
export const AGENT_ANON_ID_STORAGE_KEY = "agent_anon_id";

/**
 * Read the anon id from localStorage, minting and storing one on first use.
 * Returns undefined during SSR or when localStorage is unavailable (e.g.
 * private-mode access can throw), so callers must treat it as optional.
 */
export function getOrCreateAnonId(): string | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }

  try {
    const existing = localStorage.getItem(AGENT_ANON_ID_STORAGE_KEY);
    if (existing) {
      return existing;
    }

    const minted = crypto.randomUUID();
    localStorage.setItem(AGENT_ANON_ID_STORAGE_KEY, minted);
    return minted;
  } catch {
    return undefined;
  }
}
